(() => {
  const currentLocale = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  const isEnglish = currentLocale === 'en';
  const LOCALE_STORAGE_KEY = 'flowever_preferred_locale_v1';
  const REDIRECT_GUARD_KEY = 'flowever_locale_redirect_guard';

  function localeHref(locale) {
    let path = window.location.pathname || '/';
    path = path.replace(/^\/en(?=\/|$)/, '') || '/';
    if (locale === 'en') path = '/en' + (path === '/' ? '' : path);
    return path + window.location.search + window.location.hash;
  }

  function getStoredLocale() {
    try {
      const value = window.localStorage.getItem(LOCALE_STORAGE_KEY);
      return value === 'en' || value === 'fr' ? value : '';
    } catch (error) {
      return '';
    }
  }

  function rememberLocale(locale) {
    if (locale !== 'en' && locale !== 'fr') return;
    try {
      window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    } catch (error) {}
  }

  function browserLocale() {
    const detected = ((navigator.languages && navigator.languages[0]) || navigator.language || 'fr').toLowerCase();
    return detected.startsWith('en') ? 'en' : 'fr';
  }

  function applyAutomaticLocale() {
    const stored = getStoredLocale();
    const preferred = stored || browserLocale();

    if (!stored) rememberLocale(preferred);
    if (preferred === currentLocale) {
      try { window.sessionStorage.removeItem(REDIRECT_GUARD_KEY); } catch (error) {}
      return false;
    }

    const target = localeHref(preferred);
    const current = window.location.pathname + window.location.search + window.location.hash;
    if (!target || target === current) return false;

    try {
      const guard = window.sessionStorage.getItem(REDIRECT_GUARD_KEY);
      if (guard === target) return false;
      window.sessionStorage.setItem(REDIRECT_GUARD_KEY, target);
    } catch (error) {}

    window.location.replace(target);
    return true;
  }

  if (applyAutomaticLocale()) return;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.flowever-language-switcher a[lang]');
    if (!link) return;
    const locale = (link.getAttribute('lang') || '').toLowerCase().split('-')[0];
    rememberLocale(locale);
    try { window.sessionStorage.removeItem(REDIRECT_GUARD_KEY); } catch (error) {}
  });

  function makeSwitcher() {
    const el = document.createElement('div');
    el.className = 'flowever-language-switcher';
    el.setAttribute('aria-label', isEnglish ? 'Language' : 'Langue');
    el.innerHTML = `<a href="${localeHref('fr')}" lang="fr"${currentLocale === 'fr' ? ' aria-current="page"' : ''}>FR</a><span aria-hidden="true">/</span><a href="${localeHref('en')}" lang="en"${currentLocale === 'en' ? ' aria-current="page"' : ''}>EN</a>`;
    return el;
  }

  function installSwitcher() {
    if (document.querySelector('.flowever-language-switcher')) return;
    const switcher = makeSwitcher();
    const homeActions = document.querySelector('.fv__nav-actions');
    if (homeActions) {
      homeActions.insertBefore(switcher, homeActions.firstChild);
      return;
    }

    const productCart = document.querySelector('.fvp__cart');
    if (productCart && productCart.parentElement) {
      const wrapper = document.createElement('div');
      wrapper.className = 'fvp__nav-actions';
      productCart.parentElement.replaceChild(wrapper, productCart);
      wrapper.append(switcher, productCart);
      return;
    }

    switcher.classList.add('flowever-language-switcher--floating');
    document.body.appendChild(switcher);
  }

  if (!isEnglish) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installSwitcher, { once: true });
    else installSwitcher();
    return;
  }

  const textMap = new Map([
    ['La maison', 'The house'],
    ['Panier', 'Cart'],
    ['Notre signature', 'Our signature'],
    ['Créations florales singulières, imaginées à Igny et livrées en Île-de-France.', 'Singular floral creations, imagined in Igny and delivered throughout Île-de-France.'],
    ['Taille', 'Size'],
    ['Prix', 'Price'],
    ['Composé à la commande', 'Made to order'],
    ['Livraison par coursier en Île-de-France', 'Courier delivery throughout Île-de-France'],
    ['Retrait à Igny (91430)', 'Pickup in Igny (91430)'],
    ['Voir le bouquet', 'View bouquet'],
    ['Indisponible', 'Unavailable'],
    ['Ajouter au panier', 'Add to cart'],
    ['Ajouté', 'Added'],
    ['S, M ou L · Composé à la commande', 'S, M or L · Made to order'],
    ['Délicat', 'Delicate'],
    ['Majestueux', 'Majestic'],
    ['Votre commande', 'Your order'],
    ['Votre bouquet premium, en trois étapes', 'Your premium bouquet, in three steps'],
    ['Choisissez votre palette', 'Choose your palette'],
    ['Blush, Crimson, Golden Hour, Meadow ou Midnight : sélectionnez l’atmosphère qui traduit le mieux votre intention.', 'Blush, Crimson, Golden Hour, Meadow or Midnight: choose the mood that best expresses your intention.'],
    ['Sélectionnez le format', 'Choose the size'],
    ['S — Composition prédéfinie', 'S — Predetermined composition'],
    ['Fleurs de saison sélectionnées par Flowever, dans le respect de la palette choisie.', 'Seasonal flowers selected by Flowever while respecting the chosen palette.'],
    ['M & L — Composition libre', 'M & L — Freestyle composition'],
    ['Palette respectée, sélection florale adaptée aux arrivages, à la qualité disponible et au budget du format. L offre un volume supérieur à M.', 'The palette is respected while flower selection adapts to availability, quality and the budget of the chosen size. L offers more volume than M.'],
    ['Optez pour une taille S, M ou L selon l’occasion et l’effet souhaité.', 'Choose S, M or L depending on the occasion and the statement you want to make.'],
    ['Recevez votre création', 'Receive your creation'],
    ['Livraison par coursier en Île-de-France ou retrait convenu à Igny (91430).', 'Courier delivery throughout Île-de-France or arranged pickup in Igny (91430).'],
    ['Imaginer votre événement →', 'Imagine your event →'],
    ['Créer votre bouquet →', 'Create your bouquet →'],
    ['Questions fréquentes', 'Frequently asked questions'],
    ['Tout savoir avant de commander', 'Everything to know before ordering'],
    ['Comment commander un bouquet Flowever ?', 'How do I order a Flowever bouquet?'],
    ['Choisissez votre palette florale, sélectionnez le format S, M ou L, puis ajoutez le bouquet au panier. Vous pouvez aussi ajouter un mot personnalisé. Pour une création sur mesure, un mariage, une réception ou un projet professionnel, utilisez le formulaire « Parlons de votre projet ».', 'Choose your floral palette, select size S, M or L, then add the bouquet to your cart. You can also add a personalised note. For a bespoke creation, wedding, reception or professional project, use the project form.'],
    ['Les bouquets sont-ils disponibles immédiatement ?', 'Are bouquets available immediately?'],
    ['Chaque composition est réalisée uniquement à la commande. Indiquez la date souhaitée afin que nous puissions confirmer la faisabilité et organiser votre création.', 'Every composition is made only to order. Tell us your preferred date so we can confirm feasibility and organise your creation.'],
    ['Où livrez-vous les bouquets ?', 'Where do you deliver?'],
    ['Flowever livre vos bouquets par coursier en Île-de-France. La livraison est facturée en supplément et son tarif est confirmé selon la destination.', 'Flowever delivers bouquets by courier throughout Île-de-France. Delivery is charged separately and the rate is confirmed according to the destination.'],
    ['Le retrait à Igny est-il possible ?', 'Is pickup in Igny available?'],
    ['Oui, un retrait peut être convenu à Igny (91430), dans l’Essonne. Les modalités sont confirmées avec vous après la commande.', 'Yes, pickup can be arranged in Igny (91430), Essonne. Details are confirmed with you after the order.'],
    ['Réalisez-vous des mariages et événements ?', 'Do you create flowers for weddings and events?'],
    ['Oui. Mariages, anniversaires, réceptions privées et événements professionnels font l’objet d’une proposition florale sur mesure, à partir de votre date, de votre ambiance et de votre moodboard.', 'Yes. Weddings, birthdays, private receptions and corporate events receive a bespoke floral proposal based on your date, desired mood and moodboard.'],
    ['Une question sur une commande ?', 'A question about an order?'],
    ['Utilisez le formulaire « Question sur une commande » situé en bas de cette page. Indiquez votre numéro de commande si vous en possédez un et décrivez précisément votre demande afin que nous puissions vous répondre.', 'Use the “Question about an order” form at the bottom of this page. Include your order number if you have one and describe your request so we can get back to you.'],
    ['Service client', 'Customer care'],
    ['Question sur une commande', 'Question about an order'],
    ['Nous écrire', 'Contact us'],
    ['Décrivez la situation rencontrée et ajoutez votre numéro de commande si vous en avez un. Nous examinerons votre demande et vous répondrons par e-mail.', 'Describe the issue and include your order number if you have one. We’ll review your request and reply by email.'],
    ['Votre demande a bien été transmise. Nous reviendrons vers vous prochainement.', 'Your request has been sent. We’ll get back to you shortly.'],
    ['Nom', 'Name'],
    ['E-mail', 'Email'],
    ['Numéro de commande', 'Order number'],
    ['facultatif', 'optional'],
    ['Motif', 'Reason'],
    ['Choisir un motif', 'Choose a reason'],
    ['Commande', 'Order'],
    ['Livraison ou retrait', 'Delivery or pickup'],
    ['Bouquet reçu', 'Bouquet received'],
    ['Paiement ou remboursement', 'Payment or refund'],
    ['Autre demande', 'Other request'],
    ['Votre message', 'Your message'],
    ['Envoyer ma demande', 'Send my request'],
    ['Maison florale', 'Floral house'],
    ['Vue principale', 'Main view'],
    ['Vue du dessus', 'Top view'],
    ['Gros plan', 'Close-up'],
    ['a bien été ajouté au panier.', 'has been added to your cart.'],
    ['Ajouter un mot personnalisé (+ 5 €)', 'Add a personalised note (+ €5)'],
    ['Votre mot', 'Your message'],
    ['250 caractères maximum. Le mot sera préparé avec ce bouquet.', 'Maximum 250 characters. Your message will be prepared with this bouquet.'],
    ['Prochain workshop', 'Next workshop'],
    ['S’inscrire', 'Book now'],
    ['Les premiers workshops Flowever arrivent prochainement.', 'The first Flowever workshops are coming soon.'],
    ['Inscrivez-vous pour recevoir en priorité la date, le thème, le lieu, le tarif et l’ouverture des places.', 'Join the list to receive the date, theme, venue, price and booking opening first.'],
    ['Fleurs de saison', 'Seasonal flowers'],
    ['Petit groupe', 'Small group'],
    ['Matériel fourni', 'Materials included'],
    ['Création à emporter', 'Take-home creation'],
    ['Me prévenir', 'Notify me'],
    ['Merci, votre inscription est bien enregistrée. Vous recevrez les prochaines informations par e-mail.', 'Thank you, your registration is confirmed. You will receive upcoming information by email.'],
    ['En vous inscrivant, vous acceptez de recevoir les actualités relatives aux workshops Flowever. Vous pourrez vous désinscrire à tout moment.', 'By signing up, you agree to receive news about Flowever workshops. You can unsubscribe at any time.'],
    ['Ateliers Flowever', 'Flowever workshops'],
    ['Créer, composer, partager.', 'Create, compose, share.'],
    ['Des ateliers floraux en petit groupe pour découvrir l’art de la composition et repartir avec votre propre création.', 'Small-group floral workshops to discover the art of composition and leave with your own creation.'],
    ['Soyez informé en priorité', 'Get early access'],
    ['Laissez votre e-mail pour recevoir les prochaines dates et l’ouverture des inscriptions.', 'Leave your email to receive upcoming dates and booking openings.'],
    ['En vous inscrivant, vous acceptez de recevoir les actualités des workshops Flowever. Désinscription possible à tout moment.', 'By signing up, you agree to receive Flowever workshop news. You can unsubscribe at any time.'],
    ['Merci, votre inscription est bien enregistrée.', 'Thank you, your registration is confirmed.'],
    ['Ateliers floraux', 'Floral workshops'],
    ['Prochainement en Île-de-France', 'Coming soon in Île-de-France'],
    ['Minimum 48 h.', 'Minimum 48 hours.'],
    ['La date et le mode de remise se renseignent au panier avant le paiement.', 'Choose the date and delivery or pickup method in the cart before payment.'],
    ['Besoin de plusieurs bouquets ? Projet professionnel ou événement', 'Need several bouquets? Professional project or event'],
    ['Palette florale', 'Floral palette'],
    ['Choisissez votre palette', 'Choose your palette'],
    ['Les bouquets de fleurs fraîches et les créations personnalisées ne bénéficient pas du droit légal de rétractation, conformément à l’article L221-28 du Code de la consommation.', 'Fresh-flower bouquets and personalised creations are excluded from the statutory right of withdrawal under Article L221-28 of the French Consumer Code.'],
    ['Consulter les conditions d’annulation', 'View cancellation terms']
  ]);

  const attrMap = new Map([
    ['Navigation Flowever', 'Flowever navigation'],
    ['Flowever Paris, accueil', 'Flowever Paris, home'],
    ['Voir le panier', 'View cart'],
    ['Informations de commande et de livraison', 'Order and delivery information'],
    ['Écrivez le message qui accompagnera ce bouquet…', 'Write the message to accompany this bouquet…'],
    ['Votre adresse e-mail', 'Your email address']
  ]);

  function translateTextNode(node) {
    const raw = node.nodeValue;
    const trimmed = raw.trim();
    if (!trimmed) return;
    const translated = textMap.get(trimmed);
    if (!translated) return;
    node.nodeValue = raw.replace(trimmed, translated);
  }

  function translateElement(el) {
    if (!(el instanceof Element)) return;
    ['aria-label', 'title', 'placeholder'].forEach((attr) => {
      const value = el.getAttribute(attr);
      if (value && attrMap.has(value)) el.setAttribute(attr, attrMap.get(value));
    });
    if (el.tagName === 'OPTION') {
      const trimmed = el.textContent.trim();
      if (textMap.has(trimmed)) el.textContent = textMap.get(trimmed);
    }
  }

  function translateTree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE) translateElement(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
      else translateElement(node);
    }
  }

  function boot() {
    translateTree(document.body);
    installSwitcher();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(translateTree);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
